import axios from 'axios';
import { UserGeo } from './../../types/userGeo';

export const getGeoInfo = () => axios.get<UserGeo>('https://ipapi.co/json/');
